import { Box, Checkbox, Drawer, FormControlLabel, Grid2, LinearProgress, Switch, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { FileTypeEnum } from "../../_common/enum";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";
import { SchoolBookingStatusEnum } from "../../_common/enum/schoolBookingStatus.enum";
import { DataTypeAutoComplete } from "../../_components/autocomplete/dataType.autocomplete";
import { StandardButton } from "../../_components/button/primary.button";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { PRIMARY_COLOR } from "../../_const/color.const";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { schoolBookingService } from "../../_services/schoolBooking.service";
import { BookingCancelled } from "./_componenets/bookingCancelled";
import { BookingCancelledWarning } from "./_componenets/bookingCancelledWarning";

export const SchoolBookingManage = () => {

    let navigate = useNavigate();

    const { token } = useParams<{ token: any }>();
    const [data, setData] = useState<any>(null);
    const [cancellationReason, setCancellationReason] = useState("");
    const [isCancelled, setIsCancelled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [upload, updateUpload] = useState<{ fileTypeId: number | null, file: any | null }>({ fileTypeId: 0, file: null });


    useEffect(() => {
        fetchData();
    }, []);

    function fetchData() {
        setLoading(true);

        return schoolBookingService
            .getCustomerBooking(token)
            .then(
                (json) => {
                    console.log(json);
                    setData(json);
                }
            )
            .finally(() => {
                setLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const formData = new FormData();
        formData.append("file", upload.file);
        formData.append("bookingId", data?.id);
        formData.append("fileTypeId", (FileTypeEnum.VCFForm || 0)?.toString());

        return schoolBookingService
            .uploadVcfFile(formData)
            .then(
                () => {
                    toastr.success("Vcf File Upload was successful.");
                },
                (e) => {
                    handleErrorResponse(e);
                }
            )
            .finally(() => setIsSaving(false));
    }

    function cancelBooking(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return schoolBookingService
            .cancelCustomerBooking(data?.id, cancellationReason)
            .then(
                () => {
                    setIsCancelled(true);
                },
                (e) => handleErrorResponse(e)
            )
            .finally(() => setIsSaving(false));
    }

    function onUploadChange(event: any) {
        const _upload = upload
        _upload.file = event.target.files[0];
        updateUpload({ ..._upload });
    }

    return (
        <>
            {(!isLoading && !data) && <p>Invalid token</p> }
            {!!isLoading && <LinearProgress /> }
            {!!data &&
                <ValidatorForm
                    className="form-side-nav"
                    onSubmit={submit}
                    instantValidate>

                    {data?.schoolBookingStatusId === SchoolBookingStatusEnum.BookingCancelled && <BookingCancelledWarning />}

                    {data?.schoolBookingStatusId !== SchoolBookingStatusEnum.BookingCancelled &&
                        <>
                            {!isCancelled && <>
                                <Box display="flex" justifyContent="center">
                                    <Box display="flex" flexDirection="column" gap={5} marginBottom={{ xs: "30px", md: "100px" }}>
                                        <Box>
                                            <Typography color={PRIMARY_COLOR[5]} align="center" padding={1} fontSize={{ xs: "16px", md: "20px" }} fontFamily="Poppins">
                                                Please Upload Completed form for Booking: {data?.id}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ flexGrow: 1, padding: 2 }}>
                                            <TextField
                                                label="File to Upload"
                                                type="file"
                                                id="FormFile"
                                                required
                                                fullWidth
                                                onChange={onUploadChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Box>

                                        <Box display="flex" justifyContent="center">
                                            <StandardButton
                                                variant="primary"
                                                type="button"
                                                onClick={submit}
                                            >
                                                <Box width="100%" display="flex" justifyContent="space-around">
                                                    <Typography align="center"
                                                        fontSize={{ xs: "14px", sm: "16px", md: "16px" }}
                                                        fontWeight="600"
                                                        letterSpacing="1.5px"
                                                        textTransform="none">
                                                        Upload Form
                                                    </Typography>
                                                </Box>
                                            </StandardButton>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box display="flex" justifyContent="center">
                                    <Box display="flex" flexDirection="column" gap={5} marginBottom={{ xs: "30px", md: "100px" }}>
                                        <Box>
                                            <Typography color={PRIMARY_COLOR[5]} align="center" padding={1} fontSize={{ xs: "16px", md: "20px" }} fontFamily="Poppins">
                                                To reschedule booking please cancel this booking and create new booking
                                            </Typography>
                                        </Box>

                                        <Box sx={{ flexGrow: 1, padding: 2 }}>
                                            <Grid2 container spacing={2}>
                                                <Grid2 size={{ xs: 12 }}>
                                                    <Box>
                                                        <Typography align="left" fontFamily="Poppins">Cancellation reason ? <span style={{
                                                            color: PRIMARY_COLOR[5]
                                                        }}>*</span></Typography>
                                                    </Box>
                                                    <StandardTextValidator
                                                        key="cancellationReason"
                                                        name="cancellationReason"
                                                        validators={[`required`]}
                                                        errorMessages={['This field is required']}
                                                        fullWidth
                                                        value={cancellationReason}
                                                        onChange={(e: any) => { setCancellationReason(() => { return e.target.value }) }}
                                                        InputProps={{ sx: { borderRadius: 4 } }}
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                        </Box>

                                        <Box display="flex" justifyContent="center">
                                            <StandardButton
                                                variant="primary"
                                                type="button"
                                                onClick={cancelBooking}
                                            >
                                                <Box width="100%" display="flex" justifyContent="space-around">
                                                    <Typography align="center"
                                                        fontSize={{ xs: "14px", sm: "16px", md: "16px" }}
                                                        fontWeight="600"
                                                        letterSpacing="1.5px"
                                                        textTransform="none">
                                                        Confirm Cancellation
                                                    </Typography>
                                                </Box>
                                            </StandardButton>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                            }
                            {
                                isCancelled && <BookingCancelled />
                            }
                        </>
                    }

                </ValidatorForm >
            }
        </>
    );
};